module.exports = __webpack_public_path__ + "static/media/p1.1b622f05.jpg";